import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/orderLine/findAll')
    return data
  },

  async findAllByOrder(orderId) {
    const { data } = await repository.get(baseURL + '/orderLine/findAllByOrder?orderId=' + orderId)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/orderLine', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/orderLine', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/orderLine/' + id)
  }
}